module.exports = {
  model: { id: '', name: '', email: '', password: '', cost_centers: [], customers: [] },
}
